import { OverridableComponent } from "@mui/material/OverridableComponent";
import useStores from "../hooks/use-stores";
import { SvgIconTypeMap } from "@mui/material";

export const PAGE_SIZE = 20;

export const IsInvalid = -1;

export const DESKTOP_SIZE = 1536;

export const DEFAULT_COLOUR_INDICATOR = "#9ca3af";

export interface VmList { totalCount: number, items: any[]; };
export interface VmListT<T> { totalCount: number, items: T[]; };

export interface VmOption { id: number, label: string | number, value?: any; };
export interface VmTab { key: string | number, label: string | number; badgeCount?: number; };

export enum ColorScheme { INITIAL, ERROR, WARNING, SUCCESS, INFO, DISABLED, DARK };

export const LATEST_AREA_VER = 2;
// ================ VM Dynamic Fields ================ 
export enum FieldType { TEXT, RICH_TEXT, NUMBER, TEXT_AREA, DATE, DATE_TIME, TIME, SELECT, CHECKBOX, RADIO, EMPTY };

export interface VmDynamicField {
  id?: number,
  fieldType: FieldType,
  name?: string,
  placeHolder?: string,
  value?: string,
  colSpan?: number,
  rows?: number,
  // selections only for select & radio buttons
  selections?: VmOption[],
  selectionsCols?: number,
  error?: boolean,
  autoWidth?: boolean,
  disabled?: boolean,
  minRows?: number,
  onlyShow?: boolean,
  startAdornment?: any,
}
// ================ End VM Dynamic Fields ================ 
// ================  VM Smart Table ================ 
export interface VmTBody {
  type: VmTBodyType,
  sortKey?: string,
  colorScheme?: ColorScheme,
  isEnable?: boolean,
  fields: string[] | VmTableButton[] | {
    compareBy: any,
    compareTo: any,
    operator: "||" | ">" | ">=" | "<" | "<=" | "==" | "&&",

    true: string[] | VmTableButton[] | {
      compareBy: any,
      compareTo: any,
      operator: "||" | ">" | ">=" | "<" | "<=" | "==" | "&&",
      true: string[],
      false: string[],
      enableIndicator: boolean,
    };
    false: string[] | VmTableButton[] | {
      compareBy: any,
      compareTo: any,
      operator: "||" | ">" | ">=" | "<" | "<=" | "==" | "&&",
      true: string[],
      false: string[],
      enableIndicator: boolean,
    };
  } | {
    fields: string[],
    onClick: (req: any, event: any) => any,
  } | {
    render: (item: any) => any,
    sortBy?: (item: any) => any,
  };
};
export enum VmTBodyType {
  NO,
  TEXT,
  NUMBER,
  BOOLEAN,
  COMPLEX,
  DESCRIPTION,
  IS_TOXIC,
  IS_PREMIUM,
  CREATOR,
  CURRENCY,
  DATE,
  DATE_TIME,
  MONTH_YEAR,
  TIME,
  BUTTON,
  TEXT_LINK,
  TEXT_BUTTON,
  STATUS,
  IMAGES,
  MULTILINE,
  CLINIC_STATUS,
  CLINIC_CHIP,
  IS_ADDON,
  INSURANCE_COMPANIES,
  IS_COMPLETED,
};
export interface VmTableSearch { searchFields: string[], title: string, placeHolder?: string; }
export interface VmTableButton {
  label: string,
  icon?: OverridableComponent<SvgIconTypeMap<{}, "svg">> | any,
  onClick: (req: any, event: any) => any,
  colorScheme?: ColorScheme,
  isHidden?: (req: any) => boolean,
  // Kept visible but non-interactive, with disabledLabel (if given) replacing
  // the hover title so the row explains WHY instead of letting the click
  // through to fail server-side.
  disabled?: (req: any) => boolean,
  disabledLabel?: (req: any) => string,
};
// ================ End VM Smart Table ================ 

export const States = ["ACT", "NSW", "NT", "QLD", "SA", "TAS", "WA", "VIC"];
/**
 * Attachment Type
 * Use this type when uploading files
 * Therefore backend know which type of file is uploading
 */
export enum AttachmentType {
  IMAGE = 1, //profile video cover image
  VIDEO = 2, //profile video
  DOC = 3,
  EXCEL = 4,
  AVATAR = 5,
  REVIEW_BG = 6,
  COLLEAGUE = 7,
  DAILY_SHARING = 8,
  TONGUE_EXAM = 9,
  FACE_EXAM = 10,
  AUXILIARY_TEST = 11,
  SIGNATURE = 14,
  TONGUE_EXAM_VID = 15,
  FACE_EXAM_VID = 16,
  AUXILIARY_TEST_VID = 17,
  OTHER_EXAM = 18,
  OTHER_EXAM_VID = 19,
  PATIENT_SIGNATURE_CONSENT = 20,
  PATIENT_CONSENT_FORM = 21,
  CLINIC_LOGO = 24,
  PAYMENT = 29,
  PAYMMENT_VIDEO = 30,
  PATIENT_ATTACHMENT = 31,
}

export const GetVideoAttachmentType = (imgType: AttachmentType) => {
  switch (imgType) {
    case AttachmentType.TONGUE_EXAM:
      return AttachmentType.TONGUE_EXAM_VID;
    case AttachmentType.FACE_EXAM:
      return AttachmentType.FACE_EXAM_VID;
    case AttachmentType.AUXILIARY_TEST:
      return AttachmentType.AUXILIARY_TEST_VID;
    case AttachmentType.OTHER_EXAM:
      return AttachmentType.OTHER_EXAM_VID;
    default:
      return AttachmentType.VIDEO;
  }
};



export enum Gender { MALE, FEMALE, PREFER_NOT_TO_SAY };
/**
 * Clinic Status
 * Use this type to identify the status of a clinic
 */
export enum ClinicStatus {
  APPROVED = "A",
  PENDING = "P",
  REJECTED = "R",
  CLOSED = "C",
}

export enum Modality {
  NONE = 0,
  MASSAGE = 1,
  ACUPUNCTURE = 2,
  CHINESE_MEDICINE = 3,
  REMEDIAL_MASSAGE = 4,
  DEEP_TISSUE_MASSAGE = 5,
  SPORTS_MASSAGE = 6,
  DRY_NEEDLING = 7,
  CUPPING = 8,
  PREGNANCY_MASSAGE = 9,
  MYOTHERAPY = 10,
  ASSISTED_STRETCHING = 11,
  TRIGGER_PT_THERAPY = 12,
  MYOFASCIAL_RELEASE = 13,
  JOINT_MOBILISATION = 14,
  PHYSIO = 15,
  CHIRO = 16,
  BEAUTY = 17,
  COSMETIC_MEDICINE = 18,
}

export enum ModalityType {
  TCM, MASSAGE, OTHER
}
/**
 * Booking Status
 * Use this type to identify the status of a booking
 */
export enum BookingStatus {
  PENDING = "P",
  ONGOING = "O",
  CANCELLED = "C",
}
/**
 * Practitioner Status
 */
export enum ClinicMemberStatus {
  NO_RELATIONSHIP = "-",
  APPROVED = "A",
  REJECTED = "R",
  PENDING_OWNER_APPROVAL = "PO",
  PENDING_PRACT_APPROVAL = "PP",
  PENDING_QUIT_APPROVAL = "PQ",
  QUIT = "Q",
}
/**
 * When uploading file, we need to send this the request body in respecting to structure of this interface
 * Filename is the exact name of the file u are trying to upload with
 * Expiry date - only use for insurance file
 * Actual file, it is a BASE64 STRING! Convert it to BASE64 before uploading
 */
export interface UploadSource {
  fileName: string,
  file: string,
  attachmentCategoryId: AttachmentType,
}
/**
 * Duration Interval (in minutes)
 */
export const DURATION_STEPS = [15, 20, 25, 30, 40, 60];

/**
 * Library
 */

export type BookUploadStatus = "reading" | "done" | "error";
export type BookUploadItem = {
  id: string;
  originalName: string;
  displayName: string;
  size: number;
  type: string;
  progress: number;       // 0~100（base64 转换进度）
  status: BookUploadStatus;
  base64?: string;        // 转换后的 base64（不含前缀）
};

export type CoverDTO = { fileName: string; attachmentCategoryId: number; file: string; };
export type ChapterDTO = {
  id: number | string;
  chapterNo: number;
  savedName: string;
  extension: string; // "txt" | "pdf" | ...
  titleCn?: string;
  titleEn?: string;
};
export type CreateBookPayload = {
  titleCn: string;
  descCn: string;
  authorCn: string;
  publicationYear: string;
  covers: CoverDTO[];
  chapters: ChapterDTO[];
  tags: { tagId: number; }[];
};

export type CategoryDTO = {
  createdAt: string;
  createdBy: number;
  descCn: string;
  descEn: string;
  id: number;
  isDeleted: boolean;
  lastModifiedAt: string;
  lastModifiedBy: number;
  nameCn: string;
  nameEn: string;
};

export type BookDTO = {
  id: number;
  title: string;
  author: string;
  cover: string;        // data URL，离线可用
  content: string;
  publishedAt: string;  // YYYY-MM-DD
  isOwner?: boolean;
};

export const CMASA_ORG_INFO = {
  institutionId: 10,
  institutionName: "CMASA",
};

export enum PackageServiceType {
  PURCHASE = "PURCHASE",
  RENEW = "RENEW",
  UPGRADE = "UPGRADE",
}

/**
 * Time Unit
 */


export const TimeUnitOptions = [
  { id: 1, nameCn: '秒', nameEn: 'Second' },
  { id: 2, nameCn: '分钟', nameEn: 'Minute' },
  { id: 3, nameCn: '小时', nameEn: 'Hour' },
  { id: 4, nameCn: '天', nameEn: 'Day' },
  { id: 5, nameCn: '周', nameEn: 'Week' },
  { id: 6, nameCn: '月', nameEn: 'Month' },
  { id: 7, nameCn: '年', nameEn: 'Year' },
];

/**
 * Frequency Unit
 */

export const FrequencyUnitOptions = [
  { id: 1, nameCn: '突发', nameEn: 'sudden onset' },
  { id: 2, nameCn: '间断', nameEn: 'intermittent' },
  { id: 3, nameCn: '持续', nameEn: 'persistent' },
  { id: 4, nameCn: '反复', nameEn: 'recurrent' },
  { id: 5, nameCn: '一直', nameEn: 'always' },
  { id: 6, nameCn: '经常', nameEn: 'often' },
  { id: 7, nameCn: '偶发', nameEn: 'happen occasionally' },
  { id: 8, nameCn: '不规律的', nameEn: 'irregular' },
  { id: 9, nameCn: '不稳定的', nameEn: 'unsteady' },
  { id: 10, nameCn: '反复发作', nameEn: 'recurrent attack' },
];

/**
 * Symptom Type
 */

export enum SymptomType {
  MAIN = 1,
  ASSOCIATION = 2,
}

export const NO_PackageKey = "PURCHASE_PACKAGES";

/**
 * Sign up page
 */

export enum ClinicRole { OWNER, MEMBER, INDIVIDUAL_BUSINESS };

export type PackageType = {
  name: string,
  desc: string,
  monthPricePerPerson: number,
  yearPricePerPerson: number,
  features: PackageFeature[];
} & EntityBase;

export type PackageFeature = {
  nameEn: string,
  nameCn: string,
  content?: string,
  name: string,
  descriptions: ({
    featureId: number,
    contentEn: string,
    contentCn: string,
    content: string;
  } & EntityBase)[];
} & EntityBase;

export type EntityBase = {
  id: number,
  isDeleted: boolean,
  createdBy: number,
  createdAt: string,
  lastModifiedBy: number,
  lastModifiedAt: string,
};

export enum Platform {
  PRACTITIONER = 1
}

/**
 * Street Type
 */
export const STREE_TYPE_OPTIONS: { label: string, value: string, id: number, isFrequentUsed?: boolean }[] = [
  {
    id: 1,
    label: "Street",
    value: "ST",
    isFrequentUsed: true,
  },
  {
    id: 2,
    label: "Road",
    value: "RD",
    isFrequentUsed: true,
  },
  {
    id: 3,
    label: "Avenue",
    value: "AVE",
    isFrequentUsed: true,
  },
  {
    id: 4,
    label: "Drive",
    value: "DR",
    isFrequentUsed: true,
  },
  {
    id: 5,
    label: "Lane",
    value: "LANE",
    isFrequentUsed: true,
  },
  {
    id: 6,
    label: "Place",
    value: "PL"
  },
  {
    id: 7,
    label: "Court",
    value: "CT"
  },
  {
    id: 8,
    label: "Crescent",
    value: "CRES"
  },
  {
    id: 9,
    label: "Boulevard",
    value: "BVD"
  },
  {
    id: 10,
    label: "Parade",
    value: "PDE"
  },
  {
    id: 11,
    label: "Terrace",
    value: "TCE"
  },
  {
    id: 12,
    label: "Way",
    value: "WAY"
  },
  {
    id: 13,
    label: "Close",
    value: "CL"
  },
  {
    id: 14,
    label: "Circuit",
    value: "CCT"
  },
  {
    id: 15,
    label: "Highway",
    value: "HWY"
  },
  {
    id: 16,
    label: "Freeway",
    value: "FWY"
  },
  {
    id: 17,
    label: "Alley",
    value: "ALLY"
  },
  {
    id: 18,
    label: "Arcade",
    value: "ARC"
  },
  {
    id: 19,
    label: "Broadway",
    value: "BDWY"
  },
  {
    id: 20,
    label: "Bypass",
    value: "BYPA"
  },
  {
    id: 21,
    label: "Causeway",
    value: "CAUS"
  },
  {
    id: 22,
    label: "Centre",
    value: "CTR"
  },
  {
    id: 23,
    label: "Chase",
    value: "CH"
  },
  {
    id: 24,
    label: "Circle",
    value: "CIR"
  },
  {
    id: 25,
    label: "Concourse",
    value: "CON"
  },
  {
    id: 26,
    label: "Corner",
    value: "CNR"
  },
  {
    id: 27,
    label: "Courtyard",
    value: "CTYD"
  },
  {
    id: 28,
    label: "Cove",
    value: "COVE"
  },
  {
    id: 29,
    label: "Crest",
    value: "CRST"
  },
  {
    id: 30,
    label: "Cross",
    value: "CRSS"
  },
  {
    id: 31,
    label: "Crossing",
    value: "CRSG"
  },
  {
    id: 32,
    label: "Cul-de-sac",
    value: "CDS"
  },
  {
    id: 33,
    label: "Driveway",
    value: "DRWY"
  },
  {
    id: 34,
    label: "Esplanade",
    value: "ESP"
  },
  {
    id: 35,
    label: "Estate",
    value: "EST"
  },
  {
    id: 36,
    label: "Expressway",
    value: "EXP"
  },
  {
    id: 37,
    label: "Extension",
    value: "EX"
  },
  {
    id: 38,
    label: "Fairway",
    value: "FAWY"
  },
  {
    id: 39,
    label: "Frontage",
    value: "FRTG"
  },
  {
    id: 40,
    label: "Garden",
    value: "GDN"
  },
  {
    id: 41,
    label: "Gardens",
    value: "GDNS"
  },
  {
    id: 42,
    label: "Glade",
    value: "GLDE"
  },
  {
    id: 43,
    label: "Glen",
    value: "GLEN"
  },
  {
    id: 44,
    label: "Grange",
    value: "GRA"
  },
  {
    id: 45,
    label: "Green",
    value: "GRN"
  },
  {
    id: 46,
    label: "Grove",
    value: "GR"
  },
  {
    id: 47,
    label: "Heights",
    value: "HTS"
  },
  {
    id: 48,
    label: "Hill",
    value: "HILL"
  },
  {
    id: 49,
    label: "Junction",
    value: "JNC"
  },
  {
    id: 50,
    label: "Laneway",
    value: "LNWY"
  },
  {
    id: 51,
    label: "Link",
    value: "LINK"
  },
  {
    id: 52,
    label: "Lookout",
    value: "LKT"
  },
  {
    id: 53,
    label: "Loop",
    value: "LOOP"
  },
  {
    id: 54,
    label: "Mall",
    value: "MALL"
  },
  {
    id: 55,
    label: "Meander",
    value: "MNDR"
  },
  {
    id: 56,
    label: "Mews",
    value: "MEWS"
  },
  {
    id: 57,
    label: "Motorway",
    value: "MWY"
  },
  {
    id: 58,
    label: "Parkway",
    value: "PKWY"
  },
  {
    id: 59,
    label: "Plaza",
    value: "PLZA"
  },
  {
    id: 60,
    label: "Pocket",
    value: "PKT"
  },
  {
    id: 61,
    label: "Point",
    value: "PNT"
  },
  {
    id: 62,
    label: "Promenade",
    value: "PROM"
  },
  {
    id: 63,
    label: "Quadrant",
    value: "QDRT"
  },
  {
    id: 64,
    label: "Quay",
    value: "QY"
  },
  {
    id: 65,
    label: "Quays",
    value: "QYS"
  },
  {
    id: 66,
    label: "Ridge",
    value: "RDGE"
  },
  {
    id: 67,
    label: "Rise",
    value: "RISE"
  },
  {
    id: 68,
    label: "Roads",
    value: "RDS"
  },
  {
    id: 69,
    label: "Roadway",
    value: "RDWY"
  },
  {
    id: 70,
    label: "Route",
    value: "RTE"
  },
  {
    id: 71,
    label: "Square",
    value: "SQ"
  },
  {
    id: 72,
    label: "Strip",
    value: "STRP"
  },
  {
    id: 73,
    label: "Subway",
    value: "SBWY"
  },
  {
    id: 74,
    label: "Track",
    value: "TRK"
  },
  {
    id: 75,
    label: "Trail",
    value: "TRL"
  },
  {
    id: 76,
    label: "Turn",
    value: "TURN"
  },
  {
    id: 77,
    label: "Vale",
    value: "VALE"
  },
  {
    id: 78,
    label: "View",
    value: "VIEW"
  },
  {
    id: 79,
    label: "Views",
    value: "VIEWS"
  },
  {
    id: 80,
    label: "Walk",
    value: "WALK"
  },
  {
    id: 81,
    label: "Walkway",
    value: "WKWY"
  },
  {
    id: 82,
    label: "Wharf",
    value: "WHRF"
  },
  {
    id: 83,
    label: "Wynd",
    value: "WYND"
  }
];

/**
 * Canvas Category
 */
export enum CanvasCategory {
  FOR_DIAGNOSIS = 1,
  FOR_TREATMENT = 2,
}

// Package Key
export enum PackageKey {
  KEY_PERSONAL = 'TRIALPERSONAL',
  KEY_CLINIC = 'TRIALCLINIC',
  KEY_MINI_PKG = 'MINICLINIC',
}

export enum AddressCategory {
  PATIENT_RESIDENTIAL = 1,
  PATIENT_POSTAL = 2,
  CLINIC_ADDRESS = 3
}



export enum PainConditionTypeId {
  GENERAL = 1,
  HEAD_NECK = 2,
  RESPIRATORY = 3,
  NERVOUS_SYSTEM = 4,
  MUSCULOSKELETAL = 5,
  CARDIOVASCULAR = 6,
  SKIN_INFECTIONS = 7,
  OTHER_CONDITIONS = 8,
}

// Categories for PUT /api/Statistic/Count — one ping per prescription created,
// tagging which form UI (classic vs guided) the practitioner is on.
export const PRESCRIPTION_UI_STATISTIC_CATEGORY = {
  CLASSIC: "PrescriptionUI.V1",
  GUIDED: "PrescriptionUI.V2",
};

export const PainConditionTypes = [
  // { id: PainConditionTypeId.GENERAL, nameCn: '总览', nameEn: 'General' },
  { id: PainConditionTypeId.HEAD_NECK, nameCn: '头部 / 颈部', nameEn: 'Head/Neck', nameTh: 'ศีรษะ / คอ', nameVn: 'Đầu / Cổ' },
  { id: PainConditionTypeId.RESPIRATORY, nameCn: '呼吸系统', nameEn: 'Respiratory', nameTh: 'ระบบทางเดินหายใจ', nameVn: 'Hệ hô hấp' },
  { id: PainConditionTypeId.NERVOUS_SYSTEM, nameCn: '神经系统', nameEn: 'Nervous System', nameTh: 'ระบบประสาท', nameVn: 'Hệ thần kinh' },
  { id: PainConditionTypeId.MUSCULOSKELETAL, nameCn: '肌肉骨骼系统', nameEn: 'Musculoskeletal System', nameTh: 'ระบบกล้ามเนื้อและกระดูก', nameVn: 'Hệ cơ xương khớp' },
  { id: PainConditionTypeId.CARDIOVASCULAR, nameCn: '心血管系统', nameEn: 'Cardiovascular', nameTh: 'ระบบหัวใจและหลอดเลือด', nameVn: 'Hệ tim mạch' },
  { id: PainConditionTypeId.SKIN_INFECTIONS, nameCn: '皮肤与感染', nameEn: 'Skin & Infections', nameTh: 'ผิวหนังและการติดเชื้อ', nameVn: 'Da và nhiễm trùng' },
  { id: PainConditionTypeId.OTHER_CONDITIONS, nameCn: '其他情况 / 其他疾病', nameEn: 'Other Conditions', nameTh: 'ภาวะอื่น ๆ / โรคอื่น ๆ', nameVn: 'Tình trạng khác / Bệnh khác' },
];